import React from 'react';
import styled from 'styled-components';
import { Flex } from '../Flex';
import { type IconTextProps } from './IconText.types';

const IconText: React.FC<IconTextProps> = ({ icon, text, className, style, labelStyle, id }) => {
  return (
    <Flex alignItems="center" style={style} width="auto" className={className} id={id}>
      {icon}
      <Label style={{ cursor: 'inherit', marginLeft: '5px', ...labelStyle }}>{text}</Label>
    </Flex>
  );
};

const Label = styled.label`
  cursor: inherit;
`;

export default IconText;
